<template>
  <!-- 网络异常 -->
  <Error :reload="true" :title="$t('com_error_404')" :description="$t('com_error_404_descriptoin')">
    <Icon type="404" />
  </Error>
</template>
<script>
import Error from '@/components/Error';

export default {
  components: {
    Error,
  },
};
</script>
